import { SelfConfidenceOptionsType } from './types';

export const SELF_CONFIDENCE_OPTIONS: SelfConfidenceOptionsType = [
  {
    id: 'yes_a_lot',
    title: 'Yes, a lot',
  },
  {
    id: 'sometimes',
    title: 'Sometimes',
  },
  {
    id: 'rarely',
    title: 'Rarely',
  },
  {
    id: 'no_i_feel_confident',
    title: 'No, I feel confident',
  },
];
